export const PROJECT_DETAILS_INIT = 'PROJECT_DETAILS_INIT';
export const PROJECT_DETAILS_CURRENT_PROJECT_SET =
  'PROJECT_DETAILS_CURRENT_PROJECT_SET';
export const PROJECT_DETAILS_NAV_BAR_SELECTION =
  'PROJECT_DETAILS_NAV_BAR_SELECTION';
export const SHOW_PDF_VIEWER_SET = 'SHOW_PDF_VIEWER_SET';



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/store/action-types.js